import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import RTPlanActions from "components/RTPlanActions/RTPlanActions";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import ErrorFallback from "components/ErrorFallback/ErrorFallback";
import ActionPlansDashboard from "./ActionPlansDashboard.js";
import usePlandactionsTable from "components/RTPlanActions/usePlandactionsTable.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import postPageVisit from "services/LogService";

export default function PlanActions() {


  const appContext = useContext(AdvancedSearchContext);
  const { setPage } = appContext;

  useEffect(() => {
    setPage('planactions');
    postPageVisit('planactions');
  }, []);

  const [redirState, setRedirState] = useState(false);
  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/actionplans",
      }}
    />
  );
  const { dashboard, gridState, error, refetch, invalidate } = usePlandactionsTable();
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"actionplans"}
    >
      <GridContainer>
        <ActionPlansDashboard dashboard={dashboard} />

        <GridItem xs={12} sm={12} md={12} lg={12} xl={10}>
          <Card>
            <CardBody>
              <RTPlanActions gridState={gridState} error={error} refetch={refetch} invalidate={invalidate} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {redirecting}
    </ErrorBoundary>
  );
}
